import React from "react";
import styled from "styled-components";
import EmptyStateMessage from "../common/EmptyStateMessage";
import ProceduresMain from "../procedures/ProceduresMain";
import AddFunction from "./AddFunction";
import FunctionsContext, { FunctionsStore } from "./FunctionsContext";
import FunctionsList from "./FunctionsList";
import FunctionWorkflowHeader from "./FunctionWorkflowHeader";
import WorkflowDialog from "./WorkflowDialog";
import FunctionNotificationDialog from "./FunctionNotificationDialog";
import IWPPWorkflow from "./IWPPWorkflow";
import IWPPDeleteApproverDialog from "./IWPPDeleteApproverDialog";

const MultipleFunctionsContainer = styled.div`
  display: grid;
  grid-template-columns: 240px 1px 1fr;
`;

const OneFunctionContainer = styled.div`
  display: flex;
`;

const ListContainer = styled.div`
  background-color: white;
  overflow-y: auto;
`;

const VerticalDivider = styled.div`
  background-color: gray;
`;

const DetailsContainer = styled.div`
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
  overflow-y: hidden;
`;

const FunctionDetailsContainer = styled.div`
  width: 100%;
  overflow-y: auto;
`;

const CircularProgressContainer = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
`;

const renderContent = (context) => {
  const hasMultipleFunctions =
    context.functions.functions && context.functions.functions.length > 1;
  const Container = hasMultipleFunctions
    ? MultipleFunctionsContainer
    : OneFunctionContainer;

  return (
    <>
      <IWPPDeleteApproverDialog />
      <Container style={{ height: context.contentHeight }}>
        {hasMultipleFunctions && (
          <>
            <ListContainer>
              <FunctionsList />
            </ListContainer>
            <VerticalDivider />
          </>
        )}
        <DetailsContainer>
          {context.functions.selectedFunctionDetails &&
            context.functions.selectedFunctionDetails.id === 0 ? (
            <IWPPWorkflow />
          ) : (
            <>
              <WorkflowDialog />
              <FunctionNotificationDialog />
              {context.functions.selectedFunctionDetails && (
                <>
                  <FunctionWorkflowHeader />
                </>
              )}
              <AddFunction />
              <FunctionDetailsContainer
                style={{ height: context.contentHeight - 72 }}
              >
                {context.functions.selectedFunctionDetails && (
                  <ProceduresMain />
                )}
                {context.functions.fetchingFunctionDetails && (
                  <CircularProgressContainer>
                    {/* <CenteredLoadingIndicator contentSize={{height:context.contentHeight - 72}}/> */}
                  </CircularProgressContainer>
                )}
              </FunctionDetailsContainer>
            </>
          )}
        </DetailsContainer>
      </Container>
    </>
  );
};

const FunctionsMain = (props) => {
  return (
    <FunctionsStore>
      <FunctionsContext.Consumer>
        {(context) => {
          if (context.aboutCurrentUser) {
            if (
              context.aboutCurrentUser.isOM ||
              context.aboutCurrentUser.isAdmin ||
              context.aboutCurrentUser.isGbuAdmin
            ) {
              return renderContent(context);
            } else {
              return (
                <EmptyStateMessage>
                  You do not have permission to view this page.
                </EmptyStateMessage>
              );
            }
          } else {
            return null;
          }
        }}
      </FunctionsContext.Consumer>
    </FunctionsStore>
  );
};

export default FunctionsMain;
